// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Labels = require("../../../reason/clients/components/Labels.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationPageForSalePropertyLabels_property_graphql = require("../../../__generated__/ConversationPageForSalePropertyLabels_property_graphql.bs.js");

let convertFragment = ConversationPageForSalePropertyLabels_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageForSalePropertyLabels_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageForSalePropertyLabels_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageForSalePropertyLabels_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageForSalePropertyLabels_property_graphql.node, convertFragment, fRef);
}

let PropertyFragment_forSalePropertyMatchingType_decode = ConversationPageForSalePropertyLabels_property_graphql.Utils.forSalePropertyMatchingType_decode;

let PropertyFragment_forSalePropertyMatchingType_fromString = ConversationPageForSalePropertyLabels_property_graphql.Utils.forSalePropertyMatchingType_fromString;

let PropertyFragment = {
  forSalePropertyMatchingType_decode: PropertyFragment_forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: PropertyFragment_forSalePropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageForSalePropertyLabels(props) {
  let property = RescriptRelay_Fragment.useFragment(ConversationPageForSalePropertyLabels_property_graphql.node, convertFragment, props.property);
  let match = property.agentV2;
  let match$1 = property.forSaleMatchingType;
  if (match$1 !== undefined && (match$1 === "BROADCAST" || match$1 === "QUIET_ANONYMOUS" || match$1 === "ONE_WAY" || match$1 === "QUIET")) {
    switch (match$1) {
      case "QUIET" :
        return JsxRuntime.jsx(Labels.QuietSellerLabel.make, {});
      case "QUIET_ANONYMOUS" :
        return JsxRuntime.jsx(Labels.AnonymousMatchingLabel.make, {});
    }
  }
  if (match !== undefined && match.__typename === "AnonymousForSalePropertyAgent") {
    return JsxRuntime.jsx(Labels.AnonymousAgentLabel.make, {});
  } else {
    return null;
  }
}

let make = ConversationPageForSalePropertyLabels;

exports.PropertyFragment = PropertyFragment;
exports.make = make;
/* Labels Not a pure module */
